import * as Yup from "yup";
import { selectUserById } from "../../../../http/api/UserApi";

const checkLoginId = async (loginId, currentUserId) => {
  try {
    const res = await selectUserById({ loginId: loginId });
    const userId = res.userInfo.user?.[0]?.userId;
    const user = res.userInfo?.user?.[0]?.loginId;
    if (user === null || user === undefined) {
      return true;
    }
    if (userId === currentUserId) {
      return true;
    }
    return false;
  } catch {
    return false;
  }
};

export const validationSchema = (currentUserId) => {
  return Yup.object({
    loginId: Yup.string()
      .matches(/^[a-zA-Z0-9-_]+$/, "ログインIDは半角英数字，ﾊｲﾌﾝ(-)，ｱﾝﾀﾞｰｽｺｱ(_)のみ入力できます。")
      .required("ログインIDを半角英数字，ﾊｲﾌﾝ(-)，ｱﾝﾀﾞｰｽｺｱ(_)で入力してください。")
      .test("unique", "このログインIDはすでに使用されています。", async (value) => {
        if (!value) return true;
        const exists = await checkLoginId(value, currentUserId);
        return exists;
      }),

    password: Yup.string()
      .required("パスワードを入力してください。"),

    passAgain: Yup.string()
      .test("check-values", "パスワードが一致しません。", function(value) {
        const { password } = this.parent;
        return value === password;
      })
      .required("再度パスワードを入力してください。"),

    name: Yup.string()
      .required("氏名を入力してください。"),

    type: Yup.mixed()
      .required("種別を選択してください。")
      .test("not-selected", "種別を選択してください。", value => value !== "not"),

    customer: Yup.mixed()
      .nullable()
      .test("not-selected", "取引先を選択してください。", function(value) {
        const { type } = this.parent;
        if (type === 2) {
          return value !== "not" && value !== null;
        }
        return true;
      }),

    shop: Yup.mixed()
      .nullable()
      .test("not-selected", "店舗を選択してください。", function(value) {
        const { type } = this.parent;
        const { customer } = this.parent;
        if (type === 2 && customer !== null && customer !== "not") {
          return value !== "not" && value !== null;
        }
        return true;

      })
  });
};
